import { makeActionCreator } from '../../../utilities'
import { UserConstants } from './user.constants'

export const setAuthorization = makeActionCreator(UserConstants.SET_AUTHORIZATION, 'authState')
export const resetUser = makeActionCreator(UserConstants.RESET_USER)
export const setUserId = makeActionCreator(UserConstants.SET_USER_ID, 'userId')
export const setUserName = makeActionCreator(UserConstants.SET_USER_NAME, 'userName')
export const setService = makeActionCreator(UserConstants.SET_SERVICE, 'serviceId', 'serviceName')
export const setUserPassword = makeActionCreator(UserConstants.SET_PASSWORD, 'password')
export const setEmail = makeActionCreator(UserConstants.SET_EMAIL, 'email')
export const setDatabaseUserName = makeActionCreator(UserConstants.SET_DATABASE_USER_NAME, 'databaseUserName')
export const setUserTypeData = makeActionCreator(UserConstants.SET_USER_TYPE_DATA, 'userTypeData')
export const setUserNameVerified = makeActionCreator(UserConstants.SET_USER_NAME_VERIFIED, 'userNameVerified')
export const setNowLoginAttemptedPostOkta = makeActionCreator(
  UserConstants.SET_NOW_LOGIN_ATTEMPTED_POST_OKTA,
  'nowLoginAttemptedPostOkta'
)
export const setTempOktaAccessToken = makeActionCreator(UserConstants.SET_TEMP_OKTA_ACCESS_TOKEN, 'tempOktaAccessToken')
export const setPrivileges = makeActionCreator(UserConstants.SET_PRIVILEGES, 'privileges')
